import axios from 'axios';

let base_url;

if(typeof window !== "undefined" && window.location.host === 'test-vendor-dashboard.fanni.site') {
    base_url = 'https://fanni-testing-1603da5414b1.herokuapp.com';
} else {
    base_url = process.env.REACT_APP_API_URL;
}

 const apiClient = axios.create({
    baseURL: base_url,
    headers: {
        'Content-Type': 'application/json',
        'accept': 'application/json',
        'x-User-Agent': 'dashboard',
    }
  });

  apiClient.interceptors.request.use(
    (config) => {
      if(typeof window !== "undefined") {
        const token = window?.localStorage?.getItem('token') || false;
        if (token) {
          config.headers["Authorization"] = `Bearer ${token}`; 
        }
        const currentLang = 
          window.localStorage.getItem('i18nextLng') ||
          document.documentElement.lang || 
          (document.documentElement.dir === 'rtl' ? 'ar' : 'en');
        
        config.headers['Accept-Language'] = currentLang;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );


  apiClient.interceptors.response.use(
    (res) => {
      return res;
    },
    async (err) => {

        
        const excludedUrls = ['/b-owners/register', '/b-users/one-time-password-login', '/b-users/login'];
    
        if (!excludedUrls.includes(err.config.url) && err.response) {
           if (err?.response?.status === 401 && err?.response?.data?.category === "UNAUTHORIZED") {
              localStorage.removeItem('user');
              localStorage.removeItem('token');
              const pathLang = window.location.pathname.split('/')[1] || 'ar';
              window.location.href = `/${pathLang}/login`;
            }
        }
      return Promise.reject(err);
    }
  );

  export default apiClient;